import React from 'react';

const CloudVersion = () => {
  return (
    <div className="doc-content">
      <div className="quickstart-header">
        <p className="quickstart-category">Getting Started</p>
        <h1>Cloud Version</h1>
      </div>
      
      <div className="info-banner">
        <i className="fa-solid fa-info-circle"></i>
        <div>
          <p>The fastest way to integrate your application with MemU. Perfect for teams who want immediate access without setup complexity.</p>
        </div>
      </div>
      
      <p>We host the models, APIs, and cloud storage, ensuring your application gets the <strong>best quality AI memory</strong>.</p>
      
      <p>Perfect for teams and individuals who want <strong>immediate access</strong> without setup complexity.</p>
      
      <div className="platform-cards">
        <div className="platform-card">
          <div className="card-icon">
            <i className="fa-solid fa-bolt"></i>
          </div>
          <h3>Instant Access</h3>
          <p>Start integrating AI memories in minutes with our managed cloud infrastructure.</p>
        </div>
        
        <div className="platform-card">
          <div className="card-icon">
            <i className="fa-solid fa-cloud"></i>
          </div>
          <h3>Managed Infrastructure</h3>
          <p>We handle scaling, updates, and maintenance for optimal memory quality and performance.</p>
        </div>
      </div>
      
      <div className="platform-section">
        <h2 id="instant-access">Getting Started with MemU Cloud</h2>
        
        <h3>Step 1: Sign Up</h3>
        <p>Create your MemU account and get instant access to our managed platform:</p>
        
        <div className="platform-cards">
          <div className="platform-card">
            <div className="card-icon">
              <i className="fa-solid fa-user-plus"></i>
            </div>
            <h3>Pro</h3>
            <p>Unlimited FREE API calls of memory operations. Perfect for testing and small projects.</p>
          </div>
          
          <div className="platform-card">
            <div className="card-icon">
              <i className="fa-solid fa-rocket"></i>
            </div>
            <h3>Enterprise</h3>
            <p>Advanced analytics, and priority support for production applications.</p>
          </div>
        </div>
        
        <h3 id="step-by-step">Step 2: Get Your API Key</h3>
        <p>After signing up, navigate to your dashboard to get your API key:</p>
        
        <ol>
          <li>Visit <a href="https://memu.so" target="_blank" rel="noopener noreferrer">MemU Console</a></li>
          <li>Create a new project or select an existing one</li>
          <li>Copy your API key from the project settings</li>
          <li>Set it as an environment variable: <code>MEMU_API_KEY</code></li>
        </ol>
        
        <h3>Step 3: Start Using MemU</h3>
        <p>Use the same code examples from our Quickstart guide. The cloud version requires no additional setup!</p>
        
        <div className="info-banner" style={{backgroundColor: '#f0f9ff', borderLeft: '4px solid #3b82f6'}}>
          <i className="fa-solid fa-lightbulb" style={{color: '#3b82f6'}}></i>
          <div>
            <p><strong>Pro Tip:</strong> Monitor your usage and memory performance through our comprehensive dashboard at <a href="https://memu.so" target="_blank" rel="noopener noreferrer">memu.so</a></p>
          </div>
        </div>
        
        <h2>Cloud Features</h2>
        
        <h3>Global Infrastructure</h3>
        <ul>
          <li><strong>Multi-region deployment:</strong> Low latency worldwide</li>
          <li><strong>99.9% uptime SLA:</strong> Enterprise-grade reliability</li>
          <li><strong>Auto-scaling:</strong> Handles traffic spikes automatically</li>
        </ul>
        
        <h3>Security & Compliance</h3>
        <ul>
          <li><strong>SOC 2 Type II compliant:</strong> Enterprise security standards</li>
          <li><strong>Data encryption:</strong> In transit and at rest</li>
          <li><strong>GDPR compliant:</strong> European data protection</li>
        </ul>
      </div>
    </div>
  );
};

export default CloudVersion;
